import { useCallback, useState } from 'react';

export const useCookieConsent = () => {
  const [isVisible, setIsVisible] = useState<boolean>(
    () => !localStorage.getItem('COOKIE_CONSENT'),
  );

  const handleConsent = useCallback(() => {
    localStorage.setItem('COOKIE_CONSENT', 'true');
    setIsVisible(false);
  }, []);

  return { isVisible, handleConsent };
};
